(function(){
  var ready = (document.readyState === 'loading')
    ? new Promise(function(res){ document.addEventListener('DOMContentLoaded', res, {once:true}); })
    : Promise.resolve();

  function inViewport(el){
    if (!el) return false;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var overlapY = Math.min(vh, Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0)));
    var overlapX = Math.min(vw, Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0)));
    return (overlapY >= Math.min(r.height * 0.1, 60)) && (overlapX > 0);
  }

  function initContainer(root){
    if (!root) return;
    // Support multiple containers on a page
    root.querySelectorAll('.reveal-stagger').forEach(function(box){
      // reset for Theme Editor interactions
      box.classList.remove('is-visible');

      // reduced motion
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        box.classList.add('is-visible');
        return;
      }

      var revealed = false;
      var timer = setTimeout(function(){
        if (!revealed){ box.classList.add('is-visible'); revealed = true; }
      }, 1200);

      if (!('IntersectionObserver' in window)){
        if (inViewport(box)){ box.classList.add('is-visible'); revealed = true; clearTimeout(timer); }
        return;
      }

      if (inViewport(box)){
        box.classList.add('is-visible'); revealed = true; clearTimeout(timer);
        return;
      }

      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting || inViewport(box)){
            box.classList.add('is-visible'); revealed = true; clearTimeout(timer);
            io.disconnect();
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -18% 0px' });

      io.observe(box);
    });
  }

  function initAll(){
    document.querySelectorAll('section.eny-kit[data-section-id]').forEach(initContainer);
  }

  ready.then(initAll);

  // Theme editor hooks
  document.addEventListener('shopify:section:load', function(e){
    var id = e && e.detail && e.detail.sectionId;
    if (!id) return;
    var root = document.querySelector('section.eny-kit[data-section-id="'+id+'"]');
    initContainer(root);
  });
  document.addEventListener('shopify:section:select', function(e){
    var id = e && e.detail && e.detail.sectionId;
    if (!id) return;
    var root = document.querySelector('section.eny-kit[data-section-id="'+id+'"]');
    initContainer(root);
  });
})();
